module.exports = __webpack_public_path__ + "img/juxue5.bdf7de24.png";